function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultItemRoll = function SvgLivemapSearchresultItemRoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Raw Materials",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M668.042 147.909h-7.827c-.5-1.981-7.787-1.909-7.788.22a.891.891 0 0 0 .013.11.39.39 0 0 0-.012.063v11.875c0 1.1 1.966 1.68 3.908 1.68a5.6 5.6 0 0 0 3.583-.966h8.123a.389.389 0 0 0 .385-.393V148.3a.389.389 0 0 0-.385-.391zm-11.705-.674c2.071 0 3.139.626 3.139.894s-1.067.893-3.139.893-3.138-.626-3.138-.893 1.066-.894 3.137-.894zm0 13.835c-2.071 0-3.138-.626-3.138-.894v-11.007a8.018 8.018 0 0 0 6.277 0v11.008c0 .267-1.069.893-3.14.893zm11.321-.966h-7.414V148.7h7.413v11.4z",
    style: {
      fill: "#4da5b5",
      fillRule: "evenodd"
    },
    transform: "translate(-649.428 -143.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4469",
    style: {
      fill: "none"
    }
  }));
};
export default SvgLivemapSearchresultItemRoll;